export default "__VITE_ASSET__7b99f3cc__"